import React from 'react';

const UserInfo = ({translate, infos, params}) => (
	<div className="person-info">
		<dl className="dl-horizontal">
			{
				infos.map((info, index) => (
					<div key={index}>
						<dt>{translate(info.label)}</dt>
						<dd>{translate(info.value, params)}</dd>
					</div>
				))
			}
		</dl>
	</div>
);

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/elements/About/UserInfo.js